import React, { useEffect, useState } from 'react';
import './_finariumBalanceCard.less';
import {
  AED,
  Asset,
  Bitcoin,
  CryptoLogo,
  Ethereum,
  EUR,
  Euro,
  GBP,
  Japan,
  JPY,
  List,
  Mauritius,
  MUR,
  Uae,
  Uk,
  Usa,
  USD,
  USDC,
  USDT,
} from 'IMAGE';
import PropTypes from 'prop-types';
import Spinner from '@atoms/spinner';
import { Modal } from 'antd';

const FinariumBalanceCard = ({ balanceFinarium }) => {
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [destroyOnClose, setDestroyOnClose] = useState(true);

  useEffect(() => {
    if (balanceFinarium) {
      const count = Object.keys(balanceFinarium).length;
      setShowModal(count > 4);
    }
  }, [balanceFinarium]);

  const isLoaded = !balanceFinarium;

  const iconArray = [
    { code: 'USD', name: 'INVEST ACCOUNT', icon: USD },
    { code: 'USDT', icon: USDT },
    { code: 'USDC', icon: USDC },
    { code: 'BTC', name: 'BITCOIN', icon: Bitcoin },
    { code: 'ETH', name: 'ETHEREUM', icon: Ethereum },
    { code: 'EUR', icon: EUR },
    { code: 'JPY', icon: JPY },
    { code: 'AED', icon: AED },
    { code: 'GBP', icon: GBP },
    { code: 'MUR', icon: MUR },
    { code: 'AAPL', icon: Asset },
    { code: 'GOOG', icon: Asset },
  ];

  const toggleModal = (visible = !visible, destroyOnClose = true) => {
    setVisible(visible);
    setDestroyOnClose(destroyOnClose);
  };

  const formatNumber = (value) => {
    if (value.currency_type === 'CRYPTO') {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
      }).format(value.balance || 0);
    }

    if (value.currency_type === 'ASSET') {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 6,
      }).format(value.balance || 0);
    }
    const amount = Number(value.balance).toFixed(2);
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  const modalTitle = (
    <div className='crypto-card-modal__header'>
      <div className='crypto-card-modal__brand'>
        <CryptoLogo width={40} height={40} />
        <div className='crypto-card-modal__brand-text'>
          <div className='crypto-card-modal__brand-title'>Finarium</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='crypto-card'>
      <div className='crypto-card__header'>
        <div className='crypto-card__brand'>
          <CryptoLogo width={40} height={40} />
          <div className='crypto-card__brand-text'>
            <div className='crypto-card__brand-title'>Finarium</div>
          </div>
        </div>
        {/*<div className='icon-chevron' />*/}
      </div>

      {balanceFinarium && (
        <div className='crypto-card__main'>
          <ul className='crypto-card__list'>
            {Object.entries(balanceFinarium).map(([key, value]) => {
              const iconItem = iconArray.find((item) => item.code === key);
              const IconComponent = iconItem ? iconItem.icon : null;
              const name = iconItem ? iconItem.name : null;

              return (
                <>
                  {value?.approximate_fiat_equivalent && (
                    <li key={key} className='crypto-card__row-equivalent'>
                      <div className='crypto-card__left'>
                        {IconComponent && <IconComponent width={14} height={14} />}
                        <span className='crypto-card__ccy'>{key}</span>
                      </div>
                      <div className='crypto-card__amount'>
                        <div className='amount-current'>{formatNumber(value)}</div>
                        <div className='amount-fiat'>≈ ${value?.approximate_fiat_equivalent?.balance}</div>
                      </div>
                    </li>
                  )}

                  {!value?.approximate_fiat_equivalent && (
                    <li key={key} className='crypto-card__row'>
                      <div className='crypto-card__left'>
                        {IconComponent && <IconComponent width={14} height={14} />}
                        <span className='crypto-card__ccy'>{key}</span>
                      </div>
                      {/*<div className='crypto-card__right'>*/}
                      <div className='crypto-card__amount'>
                        {/*{getSymbolFromCurrency(key)}*/}
                        {formatNumber(value)}
                      </div>
                    </li>
                  )}
                </>
              );
            })}
          </ul>
        </div>
      )}

      {Array.isArray(balanceFinarium) && balanceFinarium.length === 0 && (
        <div className='fiat-card__main'>
          <div>To activate the wallet, please contact your personal manager.</div>
        </div>
      )}

      {showModal && (
        <div className='crypto-card__modal-label' onClick={() => toggleModal(true)}>
          <List /> <span className='text'>ALL CURRENCIES</span>
        </div>
      )}

      <Modal
        visible={visible}
        destroyOnClose={destroyOnClose}
        maskClosable={true}
        title={modalTitle}
        footer={null}
        onCancel={() => toggleModal(false)}
      >
        <div className='crypto-card-modal'>
          {balanceFinarium && (
            <div className='crypto-card__main'>
              <ul className='crypto-card__list'>
                {Object.entries(balanceFinarium).map(([key, value]) => {
                  const IconComponent = iconArray.find((item) => item.code === key)?.icon;
                  return (
                    <>
                      {value?.approximate_fiat_equivalent && (
                        <li key={key} className='crypto-card__row-equivalent'>
                          <div className='crypto-card__left'>
                            {IconComponent && <IconComponent width={14} height={14} />}
                            <span className='crypto-card__ccy'>{key}</span>
                          </div>
                          <div className='crypto-card__amount'>
                            <div className='amount-current'>{formatNumber(value)}</div>
                            <div className='amount-fiat'>≈ ${value?.approximate_fiat_equivalent?.balance}</div>
                          </div>
                        </li>
                      )}

                      {!value?.approximate_fiat_equivalent && (
                        <li key={key} className='crypto-card__row'>
                          <div className='crypto-card__left'>
                            {IconComponent && <IconComponent width={14} height={14} />}
                            <span className='crypto-card__ccy'>{key}</span>
                          </div>
                          {/*<div className='crypto-card__right'>*/}
                          <div className='crypto-card__amount'>
                            {/*{getSymbolFromCurrency(key)}*/}
                            {formatNumber(value)}
                          </div>
                        </li>
                      )}
                    </>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </Modal>

      {isLoaded && <Spinner />}
    </div>
  );
};

export default FinariumBalanceCard;
FinariumBalanceCard.propTypes = {
  balanceFinarium: PropTypes.object,
};
